module.exports = __webpack_public_path__ + "static/img/7.2.b905aca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/eng/7.2.png
// module id = OAhF
// module chunks = 0